import { addDays } from "date-fns";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../common/searchParams.utils";
import { IVtcTicketParams } from "./VctTickets.interface";
import { Container } from "./VtcTicketHeaderStyle";
import VtcTicketSearch from "./VtcTicketSearch";
import VtcTicketTable from "./VtcTicketTable";

const VtcTicketResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: IVtcTicketParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const turn_status_option = getAttributeList(params.turn_status_option);
      const withdrawal_from_date = getDateAttribute(
        params.withdrawal_from_date
      );
      const withdrawal_to_date = getDateAttribute(
        params.withdrawal_to_date,
        addDays(new Date(), 5)
      );
      return {
        ...params,
        turn_status_option,
        volante_nums,
        withdrawal_from_date,
        withdrawal_to_date,
      };
    })
  );

  return (
    <div>
      <Container>
        <h1>SEGUIMIENTO DE CITAS</h1>
      </Container>
      <VtcTicketSearch params$={params$} />
      <VtcTicketTable params$={params$} />
    </div>
  );
};

export default VtcTicketResource;
